import React, { ChangeEventHandler, useRef, useState, useEffect, MouseEventHandler } from "react";
import { ArrowDown, ArrowUp, Clear_Large } from "./ProjectIcons";
import { useTranslation } from "react-i18next";
import { radioSelectClasses } from "./tailwindClassnames";

type RadioSelectListProps = {
    optionList: any[],
    selectedList: any[],
    onChangeFilter?: MouseEventHandler,
    onChangeSearchBar?: ChangeEventHandler,
    sectionLabel: string,
    onClickLoadMore?: () => void,
    loadMore: boolean,
    loading: boolean
}

const RadioSelectList = ({
    optionList,
    selectedList,
    onChangeFilter,
    onChangeSearchBar,
    sectionLabel,
    onClickLoadMore,
    loadMore,
    loading
}: RadioSelectListProps) => {
    const { t } = useTranslation();
    const [subStr, setSubStr] = useState("");
    const [expanded, setExpanded] = useState(true);
    const toggleExpanded = () => setExpanded(!expanded);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleLoadMore = async () => {
        if (onClickLoadMore) {
            await onClickLoadMore();
        }

        // Scroll to the bottom of the container
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    }, []);

    return (
        <div className={radioSelectClasses.container}>
            {/* input box to refine list */}
            <div className={radioSelectClasses.header} onClick={toggleExpanded}>
                <label className={radioSelectClasses.sectionLabel}>{sectionLabel}</label>{expanded ? <ArrowUp /> : <ArrowDown />}
            </div>
            {expanded &&
                <div>
                    <div className="relative">
                        <input
                            id="name"
                            placeholder=""
                            value={subStr}
                            className={radioSelectClasses.input}
                            onChange={(e) => {
                                setSubStr(e.target.value)
                                onChangeSearchBar && onChangeSearchBar(e)
                            }}
                        />
                        {subStr && (
                            <button
                                className={radioSelectClasses.clearButton}
                                onClick={() => {
                                    setSubStr('')
                                    onChangeSearchBar && onChangeSearchBar({ target: { value: '' } } as any)
                                }}
                            >
                                <Clear_Large />
                            </button>
                        )}
                    </div>
                    {/* list of all the options */}
                    <div className={radioSelectClasses.listContainer} ref={scrollContainerRef}>
                        {subStr.length === 0 &&
                            optionList.map((item: any) => {
                                return item.name && (
                                    <div className={radioSelectClasses.itemContainer} key={item.id}>
                                        <input
                                            className={radioSelectClasses.radioInput}
                                            type="radio"
                                            value={item.id}
                                            id={item.attribute_name}
                                            name={item.name}
                                            checked={selectedList.map(a => a.id).includes(item.id)}
                                            onChange={onChangeFilter as any} />
                                        <label
                                            className={radioSelectClasses.radioLabel}
                                        >
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        {subStr.length > 0 &&
                            optionList.map((item: any) => {
                                return item.name && item.name.toLowerCase().includes(subStr.toLowerCase()) && (
                                    <div className={radioSelectClasses.itemContainer} key={item.id}>
                                        <input
                                            className={radioSelectClasses.radioInput}
                                            type="radio"
                                            value={item.id}
                                            id={item.attribute_name}
                                            name="radioGroup"
                                            checked={selectedList.map(a => a.id).includes(item.id)}
                                            onChange={onChangeFilter as any} />
                                        <label
                                            className={radioSelectClasses.radioLabelHover}
                                        >
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                    </div>
                    <label className={loadMore ? loading ? radioSelectClasses.loadingLabel : radioSelectClasses.loadMoreLabel : "hidden"} onClick={handleLoadMore}>{loading ? t("Loading") : t("Load More")}</label>
                </div>}

        </div>
    )
}

export default RadioSelectList;